export const normalizeEditorLinkHref = (href: string): string => {
    if (!href || href === 'https://') {
        return '';
    }

    if (/^(https?:|mailto:|tel:|sms:|ftp:|\/)/i.test(href)) {
        return href;
    }

    return `https://${href}`;
};
